import {useEffect, useRef} from "react";
import {EventLike, EventPayload, subscribeMany} from "./subscribeMany";

export const useSubscribeEvents = <E extends EventLike>(
    events: readonly E[],
    handler: (payload: EventPayload<E>) => void,
) => {
    const handlerRef = useRef(handler);

    useEffect(() => {
        handlerRef.current = handler;
    });

    useEffect(() => {
        return subscribeMany(events, payload => handlerRef.current(payload));
    }, [events]);
};

// import {useEffect} from "react";
// import {EventLike, subscribeMany} from "./subscribeMany";
//
// export const useSubscribeEvents = (
//     events: EventLike[],
//     handler: () => void,
// ) => {
//     useEffect(() => {
//         return subscribeMany(events, handler);
//     }, [events, handler]);
// };
